// Google Analytics 4 (gtag.js) helpers.
// Single source of truth for the measurement ID and the calls into gtag, so
// pageview/event tracking can be reused anywhere without re-implementing guards.

export const GA_MEASUREMENT_ID =
  process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || "G-2HW11P2N2R";

// True only once the gtag.js script has loaded and registered window.gtag.
const gtagReady = () =>
  typeof window !== "undefined" && typeof window.gtag === "function";

// Record a pageview manually. Used for client-side route changes (the initial
// load's page_view is sent automatically by gtag('config')).
export const pageview = (url) => {
  if (!GA_MEASUREMENT_ID || !gtagReady()) return;
  window.gtag("event", "page_view", {
    page_path: url,
    page_location: window.location.href,
    page_title: document.title,
  });
};

// Record a custom GA4 event, e.g. event({ action: "sign_up", category: "engagement" }).
export const event = ({ action, category, label, value, ...rest } = {}) => {
  if (!GA_MEASUREMENT_ID || !gtagReady() || !action) return;
  window.gtag("event", action, {
    ...(category !== undefined && { event_category: category }),
    ...(label !== undefined && { event_label: label }),
    ...(value !== undefined && { value }),
    ...rest,
  });
};
